import React from "react";
import { Input } from "components/Input";
import { Col, Row } from "styles";
import Steps from "./Steps";

export function Premix(props) {
  const inputHandler = (e) => {
    const copyBroiler = { ...props.broiler };
    copyBroiler.premixProductionYear = e.target.value;
    copyBroiler.premixSteps.pre.feedProductionYear = (
      e.target.value * 0.053
    ).toFixed(2);
    copyBroiler.premixSteps.initial.feedProductionYear = (
      e.target.value * 0.211
    ).toFixed(2);
    copyBroiler.premixSteps.growth.feedProductionYear = (
      e.target.value * 0.568
    ).toFixed(2);
    copyBroiler.premixSteps.final.feedProductionYear = (
      e.target.value * 0.168
    ).toFixed(2);
    props.setBroiler(copyBroiler);
  };

  return (
    <>
      <Row>
        <Col size={1}>
          <Input
            type="input"
            label="Produção Ração/Ano"
            inputType="number"
            value={props.broiler.premixProductionYear}
            onChange={inputHandler}
          />
        </Col>
        <Col size={2}>
          <Input
            type="select"
            params="premixComposition"
            item={props.broiler}
            setItem={props.setBroiler}
            label="Composição do Premix"
            placeholder="Selecione o Composição"
            options={props.config
              .filter((item) => item.key === "premixComposition")
              .map((item) => ({ value: item.description }))}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Input
            type="checkbox"
            params="premixPlaxma"
            item={props.broiler}
            setItem={props.setBroiler}
            label="Utiliza Plasma"
          />
        </Col>
        <Col>
          <Input
            type="checkbox"
            params="premixHemoglobin"
            item={props.broiler}
            setItem={props.setBroiler}
            label="Utiliza Hemoglobina"
          />
        </Col>
        <Col>
          <Input
            type="checkbox"
            params="premixAnimalFeed"
            item={props.broiler}
            setItem={props.setBroiler}
            label="Usa Ração Animal"
          />
        </Col>
        <Col>
          <Input
            type="select"
            params="premixAnimalFeedType"
            item={props.broiler}
            setItem={props.setBroiler}
            placeholder="Selecione um opção"
            options={props.config
              .filter((item) => item.key === "premixAnimalFeedType")
              .map((item) => ({ value: item.description }))}
          />
        </Col>
      </Row>
      <div
        className="kt-separator kt-separator--solid"
        style={{ marginTop: 0 }}
      />
      <Steps {...props} />
    </>
  );
}
